import * as React from 'react';
import { map } from 'lodash';
import Section from '../../../Section';
import { Event } from '../../../../../types';
import { DeltaSelect } from '../../../../../store/action/deltaActions';
import RadioQuestion from './RadioQuestion';
import './DataContent.css';

interface Props {
    onChange: DeltaSelect;
    deltaPanelId: string;
    message: string;
    selectedOptionId: string;
    questions: string[];
}

interface State {
    selected: string;
}

class DataContent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            selected: props.selectedOptionId || 'NONE'
        };
    }
    onChange(e: Event) {
        const selected = e.target.id;
        const { deltaPanelId } = this.props;

        this.setState({ selected: selected }, () => { this.props.onChange(selected, deltaPanelId); });
    }
    getQuestions(questions: string[], selected: string) {
        return map(questions, (question, index) => {
            return (
                <RadioQuestion
                    selected={selected}
                    index={index}
                    question={question}
                    onChange={(e) => this.onChange(e)}
                />
            );
        });
    }
    render() {
        const { selected } = this.state;
        const { message, questions } = this.props;

        return (
            <Section>
                <p className="delta-question">{message}</p>
                <form>
                    {this.getQuestions(questions, selected)}
                </form>
            </Section>
        );
    }
}

export default DataContent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/sections/DataContent.tsx